import { ChangeDetectorRef, EventEmitter, Output, Component, Input, OnInit, AfterContentInit, ElementRef, ViewEncapsulation} from '@angular/core';
import { PropertiesService} from "../../../Common/Services/properties.service";
import { ActivatedRoute, Params, Router, UrlSegment } from "@angular/router";
import { Location } from '@angular/common';
import TranslationsService from "../../../Common/Services/translations.service";

@Component({
  selector: 'category-browsing',
  templateUrl: './app.component.html',
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {

  constructor(public location: Location, private router: Router, private elementRef: ElementRef, private propertiesService: PropertiesService, private translationsService: TranslationsService) {
    let translations = this.elementRef.nativeElement.attributes.translations.nodeValue || '';

    if (translations) {
      translationsService.init( JSON.parse(translations) );
    }

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    if (this.elementRef.nativeElement.attributes.hasOwnProperty('sectionnav')) {
      this.propertiesService.set('sectionNav', this.elementRef.nativeElement.attributes.sectionNav.nodeValue);
    }

    if (this.elementRef.nativeElement.attributes.hasOwnProperty('displaytype')) {
      this.propertiesService.set('displayType', this.elementRef.nativeElement.attributes.displayType.nodeValue);
    }

    if (this.elementRef.nativeElement.attributes.hasOwnProperty('compareallurl')) {
      this.propertiesService.set('compareAllUrl', this.elementRef.nativeElement.attributes.compareAllUrl.nodeValue);
    }

    if (this.elementRef.nativeElement.attributes.hasOwnProperty('type')) {
      this.propertiesService.set('type', this.elementRef.nativeElement.attributes.type.nodeValue);
    }

    if (this.elementRef.nativeElement.attributes.hasOwnProperty('defaultfinish')) {
      this.propertiesService.set('defaultFinish', this.elementRef.nativeElement.attributes.defaultFinish.nodeValue);
    }

    if (this.elementRef.nativeElement.attributes.hasOwnProperty('cat')) {
      this.propertiesService.set('cat', this.elementRef.nativeElement.attributes.cat.nodeValue);
    }

    if (this.elementRef.nativeElement.attributes.hasOwnProperty('secondarycat')) {
      this.propertiesService.set('secondaryCat', this.elementRef.nativeElement.attributes.secondaryCat.nodeValue);
    }

    if (this.elementRef.nativeElement.attributes.hasOwnProperty('groupby')) {
      this.propertiesService.set('groupBy', this.elementRef.nativeElement.attributes.groupBy.nodeValue);
    }
  }

  ngOnInit() {

  }

  ngAfterContentInit() {

  }
}



// WEBPACK FOOTER //
// ./src/ts/Apps/CategoryBrowsing/src/app/app.component.ts